import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledPlatformHero = styled.section`
	color: ${CSSVars.white};
	text-align: center;
	overflow: hidden;

	background: url(/assets/hero-bg.webp);
	background-size: 100% 100%;
	background-repeat: no-repeat;
	background-position: center 0%;
	color: ${CSSVars.white};

	&.full-width {
		.hero-wrapper {
			h1 {
				max-width: 920px;
			}
		}
	}

	.hero-wrapper {
		padding: 80px 20px 50px;

		@media screen and (min-width: ${CSSVars.breakpointLG}) {
			padding: 110px 40px 80px;
		}

		> :last-child {
			margin-bottom: 0;
		}

		h1 {
			position: relative;
			z-index: 10;
			font-size: ${CSSVars.fontSize2XL};
			max-width: 750px;
			text-align: left;
			margin: 0px auto 10px;

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				margin: 0px auto 20px;
				text-align: center;
			}

			@media screen and (min-width: ${CSSVars.breakpointLG}) {
				font-size: ${CSSVars.fontSize3XL};
			}
		}

		h2 {
			position: relative;
			z-index: 10;
			margin: 0 auto;
			font-size: ${CSSVars.fontSizeLG};
			max-width: 720px;
			text-align: left;

			&.break-lines {
				white-space: pre-wrap;
				line-height: 100%;
			}

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				text-align: center;
			}

			@media screen and (min-width: ${CSSVars.breakpointLG}) {
				font-size: ${CSSVars.fontSizeXL};
			}
		}

		p {
			max-width: 930px;
			font-weight: 200;
			font-size: ${CSSVars.fontSizeMD};
			margin: 20px auto;
			text-align: left;

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				text-align: center;
			}

			@media screen and (min-width: ${CSSVars.breakpointLG}) {
				margin: 30px auto;
				font-size: ${CSSVars.fontSizeXL};
			}
		}
	}
`;
